/* eslint-disable react/destructuring-assignment */
// Copyright (c) 2017 Deere & Company

import './report-header.scss';
import DownloadToExcel from '../download-to-excel';
import PropTypes from 'prop-types';
import React from 'react';
import { exportToCSV } from '../../services/export-to-csv';

const ReportGridHeader = (props) => {

    const handleExportToCsv = () => exportToCSV(props.reportName, props.gridApi);

    return (
        <section className="report-grid-header">
            <div className="report-specific-buttons">
                {props.children}
            </div>
            {
                props.showExport ? (
                    <div
                        className="export-excel"
                    >
                        <DownloadToExcel
                            onDownload={handleExportToCsv}
                        />
                    </div>
                ) :
                    null
            }
        </section>
    );

};

ReportGridHeader.displayName = 'ReportGridHeader';
ReportGridHeader.propTypes = {
    children: PropTypes.node,
    columnApi: PropTypes.object,
    gridApi: PropTypes.object.isRequired,
    reportName: PropTypes.string,
    showExport: PropTypes.bool,
};

ReportGridHeader.defaultProps = {
    showExport: true,
};

export default ReportGridHeader;
